import React, { FC } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { FrameProps } from './Frame';
import { State } from './State';

export const Static: FC<FrameProps> = props => {
  const { id } = props;
  const componentID = id || uuidv4();

  return <State {...props} id={componentID} />;
};
